import { IApplicationState } from '../../types/store';

export const selectSavedFilters = (state: IApplicationState) => {
  return state.savedFilters;
};
